module.exports = __webpack_public_path__ + "img/app_bg.0ce6e8e3.jpg";